import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface EducationCardProps {
  degree: string;
  institution: string;
  location: string;
  year: string;
  description: string;
  icon: string;
}

const EducationCard: React.FC<EducationCardProps> = ({
  degree,
  institution,
  location,
  year,
  description,
  icon,
}) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border hover:shadow-interactive transition-all duration-300">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
            <Icon name={icon as any} size={24} className="text-white" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="font-heading font-bold text-lg text-primary mb-1">
            {degree}
          </h3>
          <p className="text-text-primary font-semibold mb-1">{institution}</p>
          <div className="flex items-center space-x-4 text-sm text-text-secondary mb-3">
            <span className="flex items-center space-x-1">
              <Icon name="MapPinIcon" size={16} />
              <span>{location}</span>
            </span>
            <span className="flex items-center space-x-1">
              <Icon name="CalendarIcon" size={16} />
              <span>{year}</span>
            </span>
          </div>
          <p className="text-text-secondary text-sm leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EducationCard;